import axios from "axios";
import baseURL from "./../api.js";

// Add response interceptor to handle PHP errors in response
axios.interceptors.response.use(
  (response) => {
    // If response is a string with PHP errors, try to extract JSON
    if (typeof response.data === 'string') {
      try {
        // Find the first '[' or '{' which indicates start of JSON
        const jsonStart = Math.max(
          response.data.indexOf('['),
          response.data.indexOf('{')
        );

        if (jsonStart > 0) {
          const jsonString = response.data.substring(jsonStart);
          response.data = JSON.parse(jsonString);
          console.warn('Extracted JSON from response with PHP errors');
        }
      } catch (e) {
        console.error('Failed to extract JSON from response:', e);
      }
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

class DataService {
    constructor() {
        this.time = new Date().getTime();
    }
    sendMessage(data) {
        return axios.post(`${baseURL}/send?${this.time}`,data);
    }
    getServicesData() {
        return axios.get(`${baseURL}/services?${this.time}`);
    }
     bookAppointment(data) {
        return axios.post(`${baseURL}/book-appointment?${this.time}`,data);
    }
    updateBookingStatus(data) {
        return axios.post(`${baseURL}/booking-status?${this.time}`,data);
    }
    bookingSlots(date) {
         return axios.get(`${baseURL}/slots?date=${date}`);
    }
    loginUser(data) {
         return axios.post(`${baseURL}/login?${this.time}`,data);
    }
     getCategories(date) {
         return axios.get(`${baseURL}/categories?${this.time}`);
    }
     getSubCategories(date) {
         return axios.get(`${baseURL}/sub-categories?${this.time}`);
    }
    getBookings(date) {
         return axios.get(`${baseURL}/bookings?${this.time}`);
    }
      addCategory(data) {
         return axios.post(`${baseURL}/add-category?${this.time}`,data);
    }

    deleteCategory(data) {
     return axios.post(`${baseURL}/delete-category?${this.time}`,data);

    }
    updateCategory(data) {
     return axios.post(`${baseURL}/edit-category?${this.time}`,data);

    }
    deleteSubCategory(data) {
     return axios.post(`${baseURL}/delete-subcategory?${this.time}`,data);

    }
    updateSubCategory(data) {
     return axios.post(`${baseURL}/edit-subcategory?${this.time}`,data);

    }
      addSubCategory(data) {
         return axios.post(`${baseURL}/add-subcategory?${this.time}`,data);
    }
     editSubCategory(data) {
         return axios.post(`${baseURL}/edit-subcategory?${this.time}`,data);
    }
    getDashboardStats(year) {
         const yearParam = year ? `&year=${year}` : '';
         return axios.get(`${baseURL}/dashboard-stats?${this.time}${yearParam}`);
    }
    getMonthlyBookings(year) {
         const yearParam = year ? `&year=${year}` : '';
         return axios.get(`${baseURL}/monthly-bookings?${this.time}${yearParam}`);
    }
        getAccessToken(){
        const token = JSON.parse(localStorage.getItem("token"));
        return token;
      }
      setAccessToken(token){
        localStorage.setItem("token", JSON.stringify(token));
      }

      deleteAccessToken(){
        localStorage.removeItem('persist:root');
        localStorage.removeItem('token');
 localStorage.removeItem('user');
        //localStorage.clear();
      }
      changePassword(data) {
         return axios.post(`${baseURL}/change-password?${this.time}`,data);
    }
        setUserDetails(user) {
         localStorage.setItem("user", JSON.stringify(user));

    }
     getUserDetails(){
        const user = JSON.parse(localStorage.getItem("user"));
        return user;
      }

      getVisitorStats() {
           return axios.get(`${baseURL}/track-visitors?${this.time}`);
     }
     blockDateTime(data) {
         return axios.post(`${baseURL}/block-dates?${this.time}`,data);
    }
    getBlockedDates() {
      return axios.get(`${baseURL}/get-block-dates?${this.time}`);
     }
     deleteBlockedDate(data) {
      return axios.post(`${baseURL}/delete-block-dates?${this.time}`,data);
     }
      getVisitorLocations() {
      return axios.get(`${baseURL}/get-visitor-locations?${this.time}`);
     }
     getPages() {
           return axios.get(`${baseURL}/pages?${this.time}`);
 
     }
      updatePage(data) {
      return axios.post(`${baseURL}/update-page?${this.time}`,data);
     }
       saveEmailSettings(data) {
      return axios.post(`${baseURL}/save-email-settings?${this.time}`,data);
     }
       getEmailSettings() {
      return axios.get(`${baseURL}/email-settings?${this.time}`);
     }
     getConfirmedBookings() {
               return axios.get(`${baseURL}/bookings-confirmed?${this.time}`);

     }
     getOpenBookings() {
               return axios.get(`${baseURL}/bookings-open?${this.time}`);

     }
      getImages() {
         return axios.get(`${baseURL}/customer-images?${this.time}`);
    }
    deleteImages(data) {
return axios.post(`${baseURL}/delete-image?${this.time}`,data);
    }
      uploadImage(data) {
return axios.post(`${baseURL}/upload-image?${this.time}`,data);
    }
     getReviews() {
         return axios.get(`${baseURL}/list-review?${this.time}`);
    }
    deleteReview(data) {
      return axios.post(`${baseURL}/delete-review?${this.time}`,data);
    }
    editReview(data) {
         return axios.post(`${baseURL}/edit-review?${this.time}`,data);
    }
    updateReviewStatus(data) {
         return axios.post(`${baseURL}/update-review-status?${this.time}`,data);
    }
    getPublicReviews(page, perPage) {
         return axios.get(`${baseURL}/public-reviews?page=${page}&perPage=${perPage}&${this.time}`);
    }
     savePromotion(data) {
         return axios.post(`${baseURL}/save-promotion?${this.time}`,data);
    }
     getPromotion(data) {
         return axios.get(`${baseURL}/get-promotions?${this.time}`);
    }
    getSalonHours() {
         return axios.get(`${baseURL}/get-timings?${this.time}`);
    }
    updateSalonHours(data) {
         return axios.post(`${baseURL}/save-timings?${this.time}`, data);
    }
    getBookingByToken(data) {
         return axios.post(`${baseURL}/get-booking-by-token?${this.time}`, data);
    }
    submitReview(data) {
         return axios.post(`${baseURL}/submit-review?${this.time}`, data);
    }

    // Booking Questions
    getBookingQuestions() {
        return axios.get(`${baseURL}/booking-questions?${this.time}`);
    }
    addBookingQuestion(data) {
        return axios.post(`${baseURL}/add-booking-question?${this.time}`, data);
    }
    editBookingQuestion(data) {
        return axios.post(`${baseURL}/edit-booking-question?${this.time}`, data);
    }
    deleteBookingQuestion(data) {
        return axios.post(`${baseURL}/delete-booking-question?${this.time}`, data);
    }

    // SEO Pages
    getSeoPages() {
        return axios.get(`${baseURL}/seo-pages?${this.time}`);
    }
    getPublicSeoPages() {
        return axios.get(`${baseURL}/public-seo-pages?${this.time}`);
    }
    getSeoPageBySlug(slug) {
        return axios.get(`${baseURL}/seo-page-by-slug?slug=${slug}&${this.time}`);
    }
    addSeoPage(data) {
        return axios.post(`${baseURL}/add-seo-page?${this.time}`, data);
    }
    editSeoPage(data) {
        return axios.post(`${baseURL}/edit-seo-page?${this.time}`, data);
    }
    deleteSeoPage(data) {
        return axios.post(`${baseURL}/delete-seo-page?${this.time}`, data);
    }

    // Users
    getUsers(page = 1, perPage = 10, search = '') {
        return axios.get(`${baseURL}/users?page=${page}&perPage=${perPage}&search=${search}&${this.time}`);
    }

    // Square Settings
    getSquareSettings() {
        return axios.get(`${baseURL}/square-settings?${this.time}`);
    }
    saveSquareSettings(data) {
        return axios.post(`${baseURL}/save-square-settings?${this.time}`, data);
    }
}
export default new DataService();